/**
 * Stari tabovi izveštaja firme osvežavaju podatke samo kad se promeni početni datum (`dates.from`). Kad se u
 * telefonskom izboru perioda promeni samo krajnji datum, tab ostaje sa starim podacima — ovaj mixin tada
 * poziva učitavanje taba (`method`). Ako se promenio i početni datum, osvežava stari posmatrač, pa se
 * ne šalje dvostruki zahtev.
 *
 * @param {string} method ime metode starog taba koja učitava podatke (npr. "fetchMeals")
 */
export const hasPeriodRefetch = (method) => ({
  computed: {
    periodKey() {
      const { from, to } = this.$store.state.report.filters.dates;
      return `${from}|${to}`;
    },
  },
  watch: {
    periodKey(key, previous) {
      const [from] = key.split("|");
      const [previousFrom] = String(previous || "").split("|");
      if (from === previousFrom && typeof this[method] === "function") {
        this[method]();
      }
    },
  },
});

export default hasPeriodRefetch;
